import Login from './components/Login';
import MasterPage from './components/MasterPage';
import Vendors from './components/Vendors';
import SignUp from './components/SignUp';
import ViewAllVendors from './components/ViewAllVendors';
import ViewAllVendorsPO from './components/ViewAllVendorsPO';
import ViewAllVendorsDeptHead from './components/ViewAllVendorsDeptHead';
import ViewAllVendorsCFO from './components/ViewAllVendorsCFO';
import ViewAllVendorsFinanceTeam from './components/ViewAllVendorsFinanceTeam';
import ViewAllUsers from './components/ViewAllUsers';
import VendorsList from './components/VendorsList';
import ViewAllInvoice from './components/ViewAllInvoice';
import ViewAllInvoiceFinanceTeam from './components/ViewAllInvoiceFinanceTeam';
import ViewAllInvoiceSecurity from './components/ViewAllInvoiceSecurity';
import ViewAllInvoiceCFO from './components/ViewAllInvoiceCFO';
import ViewAllInvoicesPO from './components/ViewAllInvoicesPO';
import ViewAllInvoiceDeptHead from './components/ViewAllInvoiceDeptHead';
import RoleAssign from './components/RoleAssign';
import { Home } from './components/Home';
import RouteDropdownPage from './components/RouteDropdownPage';
import VerifierApprovalForm from './components/VerifierApprovalForm';
import CreateInvoice from './components/CreateInvoice';
import ViewAllVendorReports from './components/ViewAllVendorReports';
import ViewAllInvoiceDetails from './components/ViewAllInvoiceDetails';
import ViewAllInvoicesVerifier from './components/ViewAllInvoicesVerifier';
import VendorMasterPage from './components/VendorMasterPage';
import UpdateData from './components/UpdateData';
import VendorAgreement from './components/VendorAgreement';
import ChangePassword from './components/ChangePasswordNew';
import LogViewer from './components/LogViewer';
import AdminAccess from './components/AdminAccessControl';
import ForgotPassword from './components/ForgotPassword';
import SsoLogin from './components/SsoLogin';
import CreateTicket from './components/CreateTicket';
import PettyCashCredit from './components/PettyCashCredit';
import PettyCashFinanceApproval from './components/PettyCashFinanceApproval';
import PettyCashDMApproval from './components/PettyCashDMApproval';
import VendorEvaluation from './components/VendorEvaluation';
import EditInvoiceFinance from './components/EditInvoiceFinance';

const routes = [
    { path: "/", label: "Home", element: Home },
    { path: "/login", label: "Login", element: Login },
    { path: "/master-page", label: "Master Page", element: MasterPage },
    { path: "/Vendors", label: "Vendors", element: Vendors },
    { path: "/sign-up", label: "Sign Up", element: SignUp },
    { path: "/ViewAllVendors", label: "View All Vendors", element: ViewAllVendors },
    { path: "/ViewAllVendorsFinanceTeam", label: "View All Vendors(Finance Team)", element: ViewAllVendorsFinanceTeam },
    { path: "/ViewAllVendorsPO", label: "View All Vendors(PO)", element: ViewAllVendorsPO },
    { path: "/ViewAllVendorsDeptHead", label: "View All Vendors(Dept Head)", element: ViewAllVendorsDeptHead },
    { path: "/ViewAllVendorsCFO", label: "View All Vendors(CFO)", element: ViewAllVendorsCFO },
    { path: "/ViewAllUsers", label: "View All Users", element: ViewAllUsers },
    { path: "/VendorsList", label: "Vendors List", element: VendorsList },
    { path: "/ViewAllInvoice", label: "View All Invoice", element: ViewAllInvoice },
    { path: "/ViewAllInvoiceFinanceTeam", label: "View All Invoice(Finance Team)", element: ViewAllInvoiceFinanceTeam },
    { path: '/EditInvoiceFinance', label: 'Edit Invoice (Finance)', element: EditInvoiceFinance },
    { path: "/ViewAllInvoiceSecurity", label: "View All Invoice(Security)", element: ViewAllInvoiceSecurity },
    { path: "/ViewAllInvoiceCFO", label: "View All Invoice(CFO)", element: ViewAllInvoiceCFO },
    { path: "/ViewAllInvoicesPO", label: "View All Invoice(PO)", element: ViewAllInvoicesPO },
    { path: "/ViewAllInvoiceDeptHead", label: "View All Invoice(Dept Head)", element: ViewAllInvoiceDeptHead },
    { path: "/RoleAssign", label: "Role Assign", element: RoleAssign },
    { path: "/RouteDropdownPage", label: "RouteDropdownPage", element: RouteDropdownPage },
    { path: "/verifier-approval", label: "Verifier Approval", element: VerifierApprovalForm },
    { path: '/CreateInvoice', label: 'CreateInvoice', element: CreateInvoice },
    {path : '/CreateInvoice/:id', label: 'CreateInvocie', element:CreateInvoice},
    { path: '/ViewAllVendorReports', label: 'VendorReports', element: ViewAllVendorReports },
    { path: '/ViewAllInvoicesVerifier', label: 'View All Invoice(Verifier)', element: ViewAllInvoicesVerifier },
    { path: '/ViewAllInvoiceDetails', label: 'InvoiceReports', element: ViewAllInvoiceDetails },
    { path: '/VendorMasterPage', label: 'VendorMasterPage', element: VendorMasterPage },
    { path: '/UpdateData', label: 'UpdateData', element: UpdateData },
    { path: '/VendorAgreement', label: 'VendorAgreement', element: VendorAgreement },
    { path: '/ChangePasswordNew', label: 'ChangePassword', element: ChangePassword },
    { path: '/LogViewer', label: 'Log Viewer', element: LogViewer },
    { path: '/AdminAccessControl', label: ' AdminAccess', element: AdminAccess },
    { path: '/forgot-password', label: 'Forgot Password', element: ForgotPassword },
    // Landing page for the central portal's SSO redirect: /sso?token=...
    { path: '/sso', label: 'Portal Sign In', element: SsoLogin },
    { path: '/CreateTicket', label: 'Create Ticket', element: CreateTicket },
    { path: '/FillPettyCashCredit',label: 'Fill Petty Cash/Credit',element: PettyCashCredit },
    { path: '/PettyCashDMApproval',label: 'Petty Cash DM Approval', element: PettyCashDMApproval},
    { path: '/PettyCashApproval', label: 'Petty Cash Finance Approval', element: PettyCashFinanceApproval },
    { path: '/VendorEvaluation', label: 'Vendor Evaluation', element: VendorEvaluation },


];
export default routes;